import clsx from 'clsx';

type Props = {
  authorities: string[];
  /** The chosen authority; `null` for All. */
  value: string | null;
  onChange: (authority: string | null) => void;
};

const CHIP = 'rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500';
const ON = 'bg-indigo-600 text-white ring-indigo-600 dark:bg-indigo-500 dark:ring-indigo-500';
const OFF = 'text-zinc-700 ring-zinc-950/10 hover:bg-zinc-100 dark:text-zinc-300 dark:ring-white/15 dark:hover:bg-zinc-700';

/** One chip per authority of a reference group, plus All: the list shows the chosen authority's members only. */
export function AuthorityChips({ authorities, value, onChange }: Props) {
  const chip = (label: string, authority: string | null) => (
    <button
      key={label}
      type="button"
      aria-pressed={value === authority}
      className={clsx(CHIP, value === authority ? ON : OFF)}
      onClick={() => onChange(authority)}
    >
      {label}
    </button>
  );
  return (
    <div role="group" aria-label="Authority" className="flex flex-wrap gap-1.5">
      {chip('All', null)}
      {authorities.map((authority) => chip(authority, authority))}
    </div>
  );
}
